// The Vue build version to load with the `import` command
import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import router from './router';
import {BootstrapVue} from 'bootstrap-vue';
import moment from 'moment';
import Utils from './commons/helper';
import store from "./store";

import axios from 'axios';
import VueAxios from 'vue-axios';
import VueCookies from 'vue-cookies';
import Notifications from 'vue-notification';

import _ from 'lodash';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/scss/app.scss';
import 'font-awesome/css/font-awesome.css';

import AdminOwnerLayout from './layouts/AdminOwnerLayout.vue';
import NoneLayout from './layouts/NoneLayout.vue';

Vue.component('AdminLayout', AdminOwnerLayout);
Vue.component('NoneLayout', NoneLayout);

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueAxios, axios);
Vue.use(VueCookies);
Vue.use(Notifications);
Vue.use(VueRouter);

Vue.prototype.$moment = moment;
Vue.prototype._ = _;
Vue.prototype.$helper = Utils;

/* filter */
Vue.filter('capitalize', function(value) {
  if (!value) {
    return '';
  }
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('currency', function(value, style = 'currency', currency = 'USD') {
  value = value * 1;
  if (typeof value !== 'number') {
    return value;
  }
  const formatter = new Intl.NumberFormat(navigator.language, {
    style: style,
    currency: currency,
    minimumFractionDigits: 2
  });
  return formatter.format(value);
});

Vue.filter('number', function(value) {
  value = value * 1;
  if (typeof value !== 'number') {
    return value;
  }
  const formatter = new Intl.NumberFormat(navigator.language);
  return formatter.format(value);
});

/* eslint-disable no-new */
// eslint-disable-next-line no-unused-vars
new Vue({
  components: {App},
  render: (h) => h(App),
  router,
  store,
  template: '<App/>'
}).$mount('#app');
